
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import Divider from '@mui/material/Divider'


export default function ModalProfile(props) { 
  function closeModal() {
    props.onClose();
  }
  return (
    <Dialog onClose={closeModal} open={props.open}>
    <Card sx={{ maxWidth: 345 }}>
      <CardHeader
        avatar={
          <Avatar sx={{backgroundColor:'#1361A4' }} aria-label="recipe" >
            {props.avatar}
          </Avatar>
        }
        action={
          <IconButton aria-label="settings">
            <CloseIcon onClick={() => {closeModal()}}/>
          </IconButton>
        }
        title={props.userName}
        subheader={ `${props.userRole}(a)`}
      />
      <Divider  sx={{backgroundColor:'blue'}}/>
      <CardContent>
        <Typography variant="body2">
          <span>{props.description}</span>
        </Typography> 
        <br/>
        <Typography variant="body2" color="text.secondary" >
          <span style={{color: 'blue'}}>Email: {props.email}</span>
        </Typography> 
      </CardContent>

    </Card>
    </Dialog>
  );
}
